<template lang="pug">
  div
    //- Loading State
    template(v-if="isFetching")
      yz-card
        yz-skeleton-loader(type="article")

    //- Error State
    template(v-else-if="isError")
      yz-empty-state-card(icon="mdi-alert-circle-outline" icon-color="yz-danger-500" :title="$t('error_message.unable_to_load_data')" :description="$t('error_message.please_try_again')" :action-label="$t('retry')" @action-click="fetchStats")

    //- Content
    v-row(v-else no-gutters)
      //- Insights section (Left side)
      v-col(cols="4")
        yz-card.py-4.px-5(height="100%")
          .yz-heading-8.mb-2 {{ $t('panel.stats_submissions') }}

          .d-flex.justify-space-between.align-center
            .yz-medium-body-sm {{ $t('panel.stats_pending') }}
            .yz-rounded-medium-7 {{ stats.pending.count }} {{ $t('panel.claims').toLowerCase() }}

          yz-divider.my-1

          .d-flex.justify-space-between.align-center
            .yz-medium-body-sm {{ $t('panel.stats_overdue') }}
            .yz-rounded-medium-7.text-danger-500 {{ stats.overdue.count }} {{ $t('panel.claims').toLowerCase() }}

      //- Payouts section (Right side)
      v-col.ml-3
        yz-card.py-4.px-5(height="100%")
          .yz-heading-8.mb-2 {{ $t('panel.stats_payouts') }}
          v-row(no-gutters)
            v-col
              v-row(no-gutters, align="center")
                v-col(cols="5")
                  .yz-medium-body-sm {{ $t('panel.stats_approved') }}
                v-spacer
                v-col(cols="3")
                  .yz-medium-body-sm.text-neutral-500 {{ stats.approved.count }} {{ $t('panel.claims').toLowerCase() }}
                v-spacer
                v-col(cols="4").d-flex.align-center.justify-end
                  .yz-rounded-medium-7 {{ stats.approved.amount | displayPrice($currency) }}
                  yz-dot.ml-2(color="yz-ascent-500" size="8px")

              yz-divider.my-1

              v-row(no-gutters, align="center")
                v-col(cols="5")
                  .yz-medium-body-sm {{ $t('panel.stats_received') }}
                v-spacer
                v-col(cols="3")
                  .yz-medium-body-sm.text-neutral-500 {{ stats.received.count }} {{ $t('panel.claims').toLowerCase() }}
                v-spacer
                v-col(cols="4").d-flex.align-center.justify-end
                  .yz-rounded-medium-7 {{ stats.received.amount | displayPrice($currency) }}
                  yz-dot.ml-2(color="yz-success-500" size="8px")

            yz-divider.mx-6(vertical)

            v-col
              v-row(no-gutters, align="center")
                v-col(cols="5")
                  .yz-medium-body-sm {{ $t('panel.stats_rejected') }}
                v-spacer
                v-col(cols="3")
                  .yz-medium-body-sm.text-neutral-500 {{ stats.rejected.count }} {{ $t('panel.claims').toLowerCase() }}
                v-spacer
                v-col(cols="4").d-flex.align-center.justify-end
                  .yz-rounded-medium-7 {{ stats.rejected.amount | displayPrice($currency) }}
                  yz-dot.ml-2(color="#F2BE37" size="8px")

              yz-divider.my-1

              v-row(no-gutters, align="center")
                v-col(cols="5")
                  .yz-medium-body-sm {{ $t('panel.stats_outstanding') }}
                v-spacer
                v-col(cols="3")
                  .yz-medium-body-sm.text-neutral-500 {{ stats.submitted.count }} {{ $t('panel.claims').toLowerCase() }}
                v-spacer
                v-col(cols="4").d-flex.align-center.justify-end
                  .yz-rounded-medium-7 {{ stats.submitted.amount | displayPrice($currency) }}
                  yz-dot.ml-2(color="yz-danger-500" size="8px")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isFetching: true,
      isError: false,
      stats: {
        pending: { count: 0, amount: 0 },
        overdue: { count: 0, amount: 0 },
        submitted: { count: 0, amount: 0 },
        approved: { count: 0, amount: 0 },
        received: { count: 0, amount: 0 },
        rejected: { count: 0, amount: 0 }
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      dates: 'clinic/getPanelClaimDates',
      beginDate: 'clinic/getPanelClaimBeginDate',
      untilDate: 'clinic/getPanelClaimUntilDate'
    })
  },
  mounted() {
    this.fetchStats()
  },
  methods: {
    async fetchStats() {
      this.isFetching = true
      this.isError = false

      try {
        const params = {}

        // Add date range filtering if dates are set
        if (this.beginDate && this.untilDate) {
          params.begin = this.beginDate
          params.until = this.untilDate
        }

        const response = await this.$axios.get(`/panels/${this.company.slug}/claims/stats`, { params })
        this.stats = {
          pending: response.data.pending || { count: 0, amount: 0 },
          overdue: response.data.overdue || { count: 0, amount: 0 },
          submitted: response.data.submitted || { count: 0, amount: 0 },
          approved: response.data.approved || { count: 0, amount: 0 },
          received: response.data.received || { count: 0, amount: 0 },
          rejected: response.data.rejected || { count: 0, amount: 0 }
        }
      } catch (error) {
        console.error('Error fetching panel stats:', error)
        this.isError = true
      } finally {
        this.isFetching = false
      }
    }
  }
}
</script>

<style scoped></style>
